import { render, staticRenderFns } from "./match-to-transaction.component.vue?vue&type=template&id=25065004&"
import script from "./match-to-transaction.component.vue?vue&type=script&lang=ts&"
export * from "./match-to-transaction.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports